var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"users"},[_c('app-data-table',{attrs:{"title":"Users","headers":_vm.headers,"items":_vm.records}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }